import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PossibleResponse, DiscoveryChatQuestion } from '../model/discovery-chat.interface';
import { Output, EventEmitter } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle'; 
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { UtilsService } from 'src/app/moov-common/services/utils/utils.service';
@Component({
  selector: 'app-chat-response-options',
  templateUrl: './chat-response-options.component.html',
  styleUrls: ['./chat-response-options.component.scss'],
  // animations: [
  //   trigger('slideInOut', [
  //     transition(':enter', [
  //       style({transform: 'translateY(-100%)'}),
  //       animate('200ms ease-in', style({transform: 'translateY(0%)'}))
  //     ]),
  //     transition(':leave', [
  //       animate('200ms ease-in', style({transform: 'translateY(-100%)'}))
  //     ])
  //   ])
  // ]
  // animations:[routerTransition()]
})
export class ChatResponseOptionsComponent
  extends BaseComponent
  implements OnInit {
  @Input() currentQuestion: DiscoveryChatQuestion;
  @Input() responseOptions?: PossibleResponse[];
  @Input() isLoading: boolean = true;
  @Input() userResponseNumber: number = 1;

  @Output() responseSelectedEvent = new EventEmitter<string[]>();
  @Output() responsesPopulatedEvent = new EventEmitter();
  isMultipleSelection: boolean = false;
  selectedResponses: string[] = [];
  showSendButton: boolean = false;
  chatParticipantInitials: string;

  
  constructor(public utilsService: UtilsService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    
    this.chatParticipantInitials = this.utilsService.getInitialis(this.user?.firstName, this.user?.lastName);
  }

  ngAfterViewChecked() {
    this.responsesPopulatedEvent.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
     this.isMultipleSelection = this.userResponseNumber > 1;
  }

  responseSelected(selectedResponse: string | string[]) {
    if (!this.isMultipleSelection) {
      let singleSelectedResponse = selectedResponse as string;
      this.responseSelectedEvent.emit([singleSelectedResponse]);
    } else {
      let selectedResponses = selectedResponse as string[];
      this.selectedResponses = selectedResponses;
    }
  }

  sendResponse() {
    this.showSendButton = false;
    this.responseSelectedEvent.emit(this.selectedResponses);
    
  }

  selectionChanged(group: any) {
    if (group.value.length == this.userResponseNumber){
      this.showSendButton = true;
    } else {
      this.showSendButton = false;
    }

    if (group.value.length > this.userResponseNumber){
      let newValue = group.value;
        newValue.shift();
      group.value = newValue;

      this.selectedResponses = group.value;
      this.showSendButton = true;
      
    } else {
      if (group.value){
        this.responseSelected(group.value);
      }
    }
    
  }

}
